import { get } from 'lodash';

const AccessVideoPod = ({ podule }) => {
  const poster = get(podule, 'media.16x9.itself') || get(podule, 'media.2x1.itself') || get(podule, 'media.1x1.itself');
  const longform = get(podule, 'media.long_form.html');

  return (
    <div className="row">
      <div className="mb-4">
        <video src={podule.location} poster={poster} width="100%" controls></video>
      </div>
      <h3>{podule.name}</h3>
      {longform && (
        <>
          <hr className="mt-4 mb-4" />
          <div dangerouslySetInnerHTML={{ __html: longform }}></div>
        </>
      )}
    </div>
  );
};

export default AccessVideoPod;
